/* eslint-disable max-lines-per-function */
import { useEffect, useRef } from "react";
import ArtworkHistoryModal from "components/jiffy/react-product-details-dtf/ArtworkHistoryModal.vue";
import DesignUploadCtaPlpPreviewClass from "components/jiffy/design-upload-cta/design-upload-cta-plp/design-upload-cta-plp-preview-class";
import DesignUploadCtaPlpCookieClass from "components/jiffy/design-upload-cta/design-upload-cta-plp/design-upload-cta-plp-cookie-class";
import { EventBus, Events } from "jiffy-store";
// eslint-disable-next-line import/no-named-as-default
import useDtfStore from "components/jiffy/react-product-details-dtf/store";

type DesignLibraryModalProps = {
  index?: number;
  singleSelectionMode?: boolean;
  reorderEnabled?: boolean;
};

type ArtworkItem = {
  url: string;
  id: string | number;
  originalImageUrl: string;
  originalMime: string;
};

type DtfStoreSlice = {
  setShowArtworkHistoryModal: (show: boolean) => void;
  showArtworkHistoryModal: boolean;
  pdpType: string;
};

// eslint-disable-next-line import/no-default-export
export default function DesignLibraryModal({
  index = 0,
  singleSelectionMode = false,
  reorderEnabled = false
}: DesignLibraryModalProps) {
  const dtfStore = useDtfStore() as unknown as DtfStoreSlice;

  const selectedArtwork = useRef<ArtworkItem | null>(null);

  const handleOpen = () => {
    dtfStore.setShowArtworkHistoryModal(true);
  };

  const handleClose = () => {
    dtfStore.setShowArtworkHistoryModal(false);
  };

  const handleBuyAgain = (artworks: ArtworkItem[]) => {
    const artwork = artworks[0];
    if (!artwork) return;
    selectedArtwork.current = artwork;
    if (dtfStore.pdpType === "non-pdp") {
      DesignUploadCtaPlpCookieClass.cookie = {
        url: artwork.url,
        id: artwork.id,
        original_image_url: artwork.originalImageUrl,
        original_mime: artwork.originalMime,
        updated_at: new Date().toISOString()
      };
      new DesignUploadCtaPlpPreviewClass({ url: artwork.url }).show();
    }
  };

  useEffect(() => {
    EventBus.on(Events.DESIGN_LIBRARY_MODAL_OPEN, handleOpen);
    return () => {
      EventBus.removeEventListener(Events.DESIGN_LIBRARY_MODAL_OPEN, handleOpen);
    };
  }, []);

  return (
    <>
      {dtfStore.showArtworkHistoryModal ? (
        <ArtworkHistoryModal
          index={index}
          singleSelectionMode={singleSelectionMode}
          reorderEnabled={reorderEnabled}
          isMade
          onClose={handleClose}
          onBuyAgain={handleBuyAgain}
          data-testid="artwork-history-modal"
        />
      ) : null}
    </>
  );
}
